import { render, staticRenderFns } from "./ChartOrderReturnsMostSku.vue?vue&type=template&id=49a1c0e6"
import script from "./ChartOrderReturnsMostSku.vue?vue&type=script&lang=js"
export * from "./ChartOrderReturnsMostSku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports